export default "__VITE_ASSET__B9fK$LgU__"